import React from 'react'


const ButtonPropertyMobile = () => {
  return (
    <div style={{paddingTop:"25px", display:"flex",justifyContent:"center",position:"relative",top:"10%"}}>
        <a href='https://formulario.yolocoliving.com.br/crm_form_kjfxt/' target="" className="btn_search_place_hero">
          Cadastrar meu imóvel
        </a> 

    {/* <div id="artax_form_div"></div>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>        */}
    </div>
  )
}

export default ButtonPropertyMobile